import { useSettings } from '@/component/Table/Settings';
import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

interface FilterContext {
  isColumnFilterVisible: boolean;
  setColumnFilterVisible: (visible: boolean) => void;
}

const Context = createContext<FilterContext>({
  isColumnFilterVisible: false,
  setColumnFilterVisible: () => {},
});

export const FilterProvider = ({ children }: { children: ReactNode }) => {
  const { showColumnFilterOnLoad } = useSettings();
  const [isColumnFilterVisible, setColumnFilterVisible] = useState(
    showColumnFilterOnLoad
  );

  return (
    <Context.Provider
      value={{ isColumnFilterVisible, setColumnFilterVisible }}
      children={children}
    />
  );
};

export const useIsFilterVisible = () => {
  const { isColumnFilterVisible, setColumnFilterVisible } = useContext(Context);
  return [isColumnFilterVisible, setColumnFilterVisible] as const;
};
